import { render, staticRenderFns } from "./WorksHeader.vue?vue&type=template&id=2e7da67d&scoped=true&"
import script from "./WorksHeader.vue?vue&type=script&lang=js&"
export * from "./WorksHeader.vue?vue&type=script&lang=js&"
import style0 from "./WorksHeader.vue?vue&type=style&index=0&id=2e7da67d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7da67d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardTitle,VIcon,VTextField})
